import React from 'react';

export const COLOUR2 = {
  BLUE: '#072241',
  WHITE: '#ffffff',
};
const IconEuroSymbol = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2064 36.6916C28.8647 36.6916 36.6921 28.8632 36.6921 19.2059C36.6921 9.54867 28.8647 1.72021 19.2064 1.72021C9.54813 1.72021 1.7207 9.54867 1.7207 19.2059C1.7207 28.8632 9.54813 36.6916 19.2064 36.6916Z"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0017 27.5689C17.543 27.5689 13.1191 26.0486 13.1191 19.2066C13.1191 12.3635 17.543 10.8433 23.0017 10.8433"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8438 21.4865H19.2071"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8438 18.4454H20.7273"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconEuroSymbol;
